import { DestroyRef, Directive, DOCUMENT, ElementRef, inject, output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[clickOutside]',
})
export class ClickOutsideDirective {
  clickOutside = output<void>();

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    const onDocumentClick = (event: Event) => {
      if (!(this.elementRef.nativeElement as HTMLElement).contains(event.target as Node)) {
        this.clickOutside.emit();
      }
    };

    // Listen to click events on the document (capture phase)
    this.document.addEventListener('click', onDocumentClick, true);

    // Remove the event listener when the directive is destroyed
    this.destroyRef.onDestroy(() => {
      this.document.removeEventListener('click', onDocumentClick, true);
    });
  }
}
